import { GET_EXPORTED_XEROS } from 'Reducers/Xero/const'

export const getExportedXeros = () => ({
  type: GET_EXPORTED_XEROS,
})



// WEBPACK FOOTER //
// ./src/Reducers/Xero/actions.js